window.onload = function(e){ 
  
  var CollectionPageAddToCartWrapper = document.getElementsByClassName("boost-pfs-addtocart-wrapper");
  
  var collectionProductGTMPush = function() {    
    var productInfo = this.parentNode.parentNode.parentNode.parentNode.getElementsByClassName('boost-pfs-filter-product-bottom-inner')[0];
    var productTitle = productInfo.getElementsByClassName('boost-pfs-filter-product-item-title')[0].innerText;
    var productPrice = productInfo.getElementsByClassName('boost-pfs-filter-product-item-regular-price')[0].innerText;
    
    dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [{
          'item_name': productTitle,
          'price': productPrice,
          'quantity': '1'
        }]
      }
    });
    
  };
  
  for (var i = 0; i < CollectionPageAddToCartWrapper.length; i++) {
      CollectionPageAddToCartWrapper[i].addEventListener('click', collectionProductGTMPush, false);
  }

}